import React, { useCallback, useMemo } from 'react';
import TicketItem from '../ticketItem';
import VirtualScroller from '../virtualScroller';

function TicketWrapper({
  t,
  tickets = [],
  winNumbersForTickets = [],
  isShowBetInfo = true,
  isBetsClosed = false,
  currencyCode = 'USD',
  handleDeleteTicket = () => {},
  isFromFairness,
}) {
  const settings = useMemo(() => {
    return {
      itemHeight: 200,
      amount: 5,
      tolerance: 2,
      minIndex: 0,
      maxIndex: tickets.length,
      startIndex: 0,
    };
  }, [tickets]);

  const getData = useCallback(
    (offset, limit) => {
      const data = [];
      const start = Math.max(settings.minIndex, offset);
      const end = Math.min(offset + limit - 1, settings.maxIndex);
      if (start <= end) {
        for (let i = start; i <= end; i += 1) {
          data.push({ index: i, step: i });
        }
      }
      return data;
    },
    [settings]
  );

  const rowTemplate = useCallback(
    ({ step }) => {
      if (!tickets[step]) {
        return null;
      }
      const { ticketNumber, numbers, possibleWin, status, winAmount, amount, odd } = tickets[step];
      return (
        <TicketItem
          t={t}
          odd={odd}
          status={status}
          numbers={numbers}
          key={ticketNumber}
          betAmount={amount}
          winAmount={winAmount}
          winNumbersForTickets={winNumbersForTickets}
          possibleWin={possibleWin}
          ticketNumber={ticketNumber}
          isBetsClosed={isBetsClosed}
          currencyCode={currencyCode}
          isShowBetInfo={isShowBetInfo}
          handleDeleteTicket={handleDeleteTicket}
        />
      );
    },
    [
      tickets,
      currencyCode,
      handleDeleteTicket,
      isBetsClosed,
      isShowBetInfo,
      t,
      winNumbersForTickets,
    ]
  );

  return (
    <VirtualScroller
      className='viewport'
      get={getData}
      settings={settings}
      row={rowTemplate}
      isFromFairness={isFromFairness}
    />
  );
}

export default TicketWrapper;
